import { Container } from "react-bootstrap";

const BlockchainCaseStudy = () => {
    return (
        <section className="case-study-content-block py-5">
            <Container>
                <div>
                    <h2 className="text-primary ft-wt-700 mb-4">
                        Blockchain-Powered Asset Verification Platform for Real Estate
                    </h2>

                    <h3 className="text-primary ft-wt-700 mb-3">The Challenge</h3>

                    <p>
                        In the real estate sector, verifying property documents and
                        ownership history involves time-consuming legal reviews and
                        third-party verifications. A property tech startup approached us to
                        develop a system that could bring transparency and tamper-proof
                        record keeping into this process. The main challenge was ensuring
                        trust, immutability, and auditability of records while maintaining
                        a user-friendly experience for all stakeholders.
                    </p>

                    <h3 className="text-primary ft-wt-700 mb-3">The Solution</h3>

                    <p>
                        We designed a blockchain-based document registry using Ethereum to
                        hash and store verification proofs of property records. Each
                        document uploaded through the platform was verified, hashed, and
                        stored on the blockchain with metadata linked to a unique token ID.
                        Smart contracts handled access controls, transfer of ownership, and
                        verification requests. A React-based frontend allowed users to
                        submit documents, view their verification status, and generate proof
                        for third-party auditors — all in a secure and verifiable manner.
                    </p>

                    <h3 className="text-primary ft-wt-700 mb-3">The Benefits</h3>

                    <p>Key advantages achieved with the solution include:</p>
                    <ul>
                        <li>Immutable verification of real estate records on blockchain</li>
                        <li>Reduced dependency on intermediaries for title validation</li>
                        <li>Faster property transactions with automated smart contracts</li>
                        <li>Increased trust and transparency among buyers and legal teams</li>
                        <li>Future-proof infrastructure for digital property ownership</li>
                    </ul>
                </div>
            </Container>
        </section>
    );
};

export default BlockchainCaseStudy;
